import React from "react";
import {ToggleWrapper} from "./ToggleWrapper";
import {ToggledFeature} from "./featureToggleService";

export function ClientAppToggleWrapper(
  props: {
    children: React.ReactNode;
  }
) {
  return (
    <ToggleWrapper feature={ToggledFeature.CLIENT_APP}>
      {props.children}
    </ToggleWrapper>
  );
}
